/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StationComparisonInterface {
  selectedStationIds: string[];
}

const localStorageKey = 'selectedStationIds';

const initialState: StationComparisonInterface = {
  selectedStationIds: JSON.parse(localStorage.getItem(localStorageKey) || '[]'),
};

export const stationComparisonSlice = createSlice({
  name: 'station-comparison',
  initialState,
  reducers: {
    /**
     * Adding selected station ids
     * @param state The current state
     * @param action The payload action containing station IDs
     */
    setSelectedStationIds: (state, action: PayloadAction<string[]>) => {
      state.selectedStationIds = action.payload;
      localStorage.setItem(localStorageKey, JSON.stringify(action.payload));
    },
  },
});

export const { setSelectedStationIds } = stationComparisonSlice.actions;
export default stationComparisonSlice.reducer;
